import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { translate } from '@jsverse/transloco';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-threshold-dialog-component',
  templateUrl: './threshold-dialog-component.html',
  styleUrl: './threshold-dialog-component.scss',
  standalone: false
})
export class ThresholdDialogComponent implements OnInit, OnDestroy {
  currentTime: number = Date.now();
  private timeInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    public dialogRef: MatDialogRef<ThresholdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public activityProgressService: ActivityProgressService,
  ) {}

  ngOnInit(): void {
    this.timeInterval = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  }

  get estimatedTime(): string {
    return this.activityProgressService.formatDuration(this.data.expectedDurationMs);
  }

  get elapsedTime(): string {
    return this.activityProgressService.formatDuration(this.data?.health?.elapsedDurationMs);
  }
  
  onAbort(): void {
    this.dialogRef.close('abort');
  }
}
